import { gql } from "gql";
import { UpsellAdLocation } from "gql/graphql";
import { apolloClient } from "src/api/apolloClient";

export const GET_UPSELL_AD_DATA = gql(`
  query UpsellAdDataList($accessCode: String!, $adLocation: UpsellAdLocation) {
    upsellAdDataList(accessCode: $accessCode, adLocation: $adLocation) {
      upsellAdData {
        upsellAdType
        upsellAdLocation
        upsellAdIdentifier
        content {
          __typename
          ... on HealthReportUpsellContent {
            productName
            startsAtPriceText
            disclaimers
            healthReportUpsellPageTitle
            healthReportUpsellPageSubtitle
            headerImageUrl
            learnMorePageTitle
            upsellAdUrl

            primaryButton {
              text
              target
              style
              size
            }

            secondaryButton {
              text
              target
              style
              size
            }

            biologicalAgeInfo {
              currentAge
              healthyBmiAge
            }

            valueProps {
                imageUrl
                text
            }

            healthMetricsOverview {
                metricClaimFraming
                arrowImageUrl
            }

            healthMetricUpsellContentGroups {
              subtitle
              metrics {
                metricType
                label
                metricTitle
                metricDescription
                footnotes
                labelDescription
              }
            }
          }
        }
      }
    }
  }
`);

export const getUpsellAdDataQuery = (
  accessCode: string,
  adLocation: UpsellAdLocation
) =>
  apolloClient.query({
    query: GET_UPSELL_AD_DATA,
    variables: {
      accessCode,
      adLocation,
    },
  });
